import { IJurisdiction } from '../model';

/** True for US state / sub codes such as `US.IL` or `us.de` (case-insensitive). */
export function isUsDotSubJurisdictionCode(jurisdictionCode: string | undefined): boolean {
    return !!jurisdictionCode && jurisdictionCode.toLowerCase().startsWith('us.');
}

function findJurisdictionByCode(
    jurisdictions: IJurisdiction[] | null | undefined,
    jurisdictionCode: string | undefined
): IJurisdiction | undefined {
    return jurisdictions?.find((jurisdiction) => jurisdiction.code === jurisdictionCode);
}

/**
 * Resolves which jurisdiction the Enter Amounts dialog should start with.
 * For `us.*` codes, prefers the API default when present; otherwise uses the report code match.
 * For other codes, prefers the report code match when present; otherwise the API default.
 */
export function resolveEnterAmountsDefaultJurisdiction(
    jurisdictions: IJurisdiction[] | undefined,
    jurisdictionCodeFromReport: string | undefined
): IJurisdiction | undefined {
    const jurisdictionFromRoute: IJurisdiction | undefined = findJurisdictionByCode(jurisdictions, jurisdictionCodeFromReport);
    const jurisdictionFromApiDefault: IJurisdiction | undefined = jurisdictions?.find((jurisdiction) => jurisdiction.isDefaultJurisdiction);
    if (isUsDotSubJurisdictionCode(jurisdictionCodeFromReport)) {
        return jurisdictionFromApiDefault ?? jurisdictionFromRoute;
    }
    return jurisdictionFromRoute ?? jurisdictionFromApiDefault;
}
